import { useEffect } from 'react';
import { fromLonLat } from 'ol/proj';

export const useGeolocation = ({
    trackLocation = true,
    options = {},
    onError = () => {},
    onPosition = () => {},
    projection = 'EPSG:27700'
}
) => {
    const handleGotPosition = position => {
        if (trackLocation) {
            const newCoords = fromLonLat([position.coords.longitude, position.coords.latitude], projection);
            const results = {
                accuracy: position.coords.accuracy,
                altitude: position.coords.altitude,
                altitudeAccuracy: position.coords.altitudeAccuracy,
                heading: position.coords.heading,
                longitude: newCoords[0],
                latitude: newCoords[1],
                speed: position.coords.speed,
                timestamp: position.timestamp
            };
            onPosition(results);
        }
    };

    const handleError = error => {
        onError(error);
    };

    useEffect(() => {
        if (trackLocation) {
            navigator.geolocation.getCurrentPosition(handleGotPosition, handleError, options);
            // Note; this doesn't continually track the user. We could look into watchPosition/clearWatch if we need that
            // in future.
        }
        return () => {
            // switch flag off in case we get unmounted before getCurrentPosition calls back
            trackLocation = false;
            // clear any watchPosition ids here if we're doing that.
        };
    }, [trackLocation]);
};
